import { Component } from '@angular/core'
import { GlobalConstants } from 'src/app/constants/global-constants'
import {
  CREATED_ON,
  CALENDAR_DISPLAY_FOR,
  CALENDAR_DISPLAY_ID,
  CALENDAR_FROM,
  CALENDAR_TASK_DATE,
  CALENDAR_TO,
  COMPANY_ENTITY_DISPLAY_ID
} from 'src/app/constants/ui.columns'
import {
  SummaryDataTableComponent,
  SummaryDataTableData,
  SummaryDataTableOptions
} from '../../common/summary-data-table/summary-data-table.component'
import { CalendarEventAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import { Observable } from 'rxjs'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { load_calendar_summary_action } from 'src/app/store/action/calendar.action'
import { getAllCalendarSummary } from 'src/app/store/selector/calendar.selector'
import { DocumentService } from 'src/app/services/common/document.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'

@Component({
  selector: 'app-summary-calendar',
  templateUrl: './summary-calendar.component.html',
  styleUrls: ['./summary-calendar.component.scss']
})
export class SummaryCalendarComponent {
  fromDate: any
  toDate: any
  summaryOptions: SummaryDataTableOptions
  calendarList$: Observable<PaginatedAPI<CalendarEventAPIModel>>
  summaryData: SummaryDataTableData<CalendarEventAPIModel>

  queryParamValues = {
    pageNo: 0,
    pageLimit: SummaryDataTableComponent.defaultLimitDropdownValue,
    sortBy: 'displayId',
    sortOrder: 'ASC'
  }
  searchRequestBody = {}

  constructor(private route: Router, private appState: Store<AppState>, private documentService: DocumentService) {
    this.calendarList$ = this.appState.select(getAllCalendarSummary())
    this.summaryOptions = {
      downloadable: true,
      additionalButtons: true,
      contentSelectable: true,
      contentSelector: false,
      filterable: true,
      formattedContent: false,
      pageable: true,
      sortable: true,
      quickFilters: true
    }
  }
  ngOnInit(): void {
    this.loadSummaryData()
    this.summaryData = {
      content$: this.calendarList$,
      contentSelector: null,
      headers: [
        COMPANY_ENTITY_DISPLAY_ID,
        CALENDAR_DISPLAY_ID,
        CREATED_ON,
        CALENDAR_FROM,
        CALENDAR_TO,
        CALENDAR_TASK_DATE,
        CALENDAR_DISPLAY_FOR
      ],
      additionalButtons: [
        {
          id: 'new-calendar',
          label: 'NEW CALENDAR TASK',
          route: `/${GlobalConstants.ROUTING.CALENDAR_INFO}/${GlobalConstants.ROUTING.NEW}`
        }
      ],
      currentSearchParams: this.queryParamValues,
      sortCallback: this.sortCallback,
      checkBoxSelectionIds: [],
      searchCallback: this.searchCallback,
      selectPageCallback: this.selectPageCallback,
      onDropdownLimitChange: this.onDropdownLimitChange,
      downloadDocumentCallback: this.downloadDocumentCallback
    }
  }

  searchCallback = searchParams => {
    this.queryParamValues.pageNo = 0
    this.searchRequestBody = {
      ...searchParams
    }
    this.loadSummaryData()
  }

  onViewForChange = event => {
    this.queryParamValues.pageLimit = event.target.value
    this.loadSummaryData()
  }

  sortCallback = (columnCode, order) => {
    this.queryParamValues.sortBy = columnCode
    this.queryParamValues.sortOrder = order
    this.loadSummaryData()
  }

  private loadSummaryData() {
    let options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.appState.dispatch(load_calendar_summary_action(options))
  }

  buildQueryParams = (buildForDownload = false): { key: string; value: string }[] => {
    return [
      {
        key: 'pageNo',
        value: buildForDownload
          ? GlobalConstants.FILE_DOWNLOAD_CONFIG.PAGE_NUMBER.toString()
          : this.queryParamValues.pageNo.toString()
      },
      {
        key: 'limit',
        value: buildForDownload
          ? GlobalConstants.FILE_DOWNLOAD_CONFIG.ROW_LIMIT.toString()
          : this.queryParamValues.pageLimit.toString()
      },
      {
        key: 'sortBy',
        value: this.queryParamValues.sortBy
      },
      {
        key: 'sortOrder',
        value: this.queryParamValues.sortOrder
      }
    ]
  }

  selectPageCallback = pageNum => {
    this.searchRequestBody = {}
    this.queryParamValues.pageNo = pageNum
    this.loadSummaryData()
  }
  dateSelection() {
    if (this.fromDate && this.toDate) {
      this.searchRequestBody = {
        filterFrom: this.fromDate,
        filterTo: this.toDate
      }
      this.loadSummaryData()
    }
  }

  private onDropdownLimitChange = (limit: number) => {
    this.queryParamValues.pageLimit = limit
    this.loadSummaryData()
  }

  downloadDocumentCallback = documentType => {
    const checkBoxSelectionIds = this.summaryData.checkBoxSelectionIds
    if (checkBoxSelectionIds.length > 0) {
      this.searchRequestBody = {
        ids: checkBoxSelectionIds
      }
    }
    const endPoint = `${ServiceUrlConstants.API_CALENDAR_SUMMARY_LIST_EXPORT + documentType}`
    const options = {
      queryParams: this.buildQueryParams(true),
      requestBody: this.searchRequestBody
    }
    this.documentService.downloadDocument(endPoint, options)
  }
}
